// @flow strict
import * as React from 'react'
import cx from 'classnames'
import { Link } from 'gatsby'

import Media from './Media'
import Content from './Content'
import Heading from './Heading'
import Text from './Text'
import Metadata from './Metadata'
import Label from './Label'
import Picture from './Picture'
import ContentHeader from './ContentHeader'

import styles from './Card.module.scss'

export type Props = {
  children: React.ChildrenArray<React.Element<typeof Media | typeof Content>>,
  as: React.Element<'article' | 'a' | typeof Link>,
  horizontal?: boolean,
  className?: string,
}

const Card = ({ as, children, className }: Props) =>
  React.cloneElement(
    as,
    {
      className: cx(styles.card, className),
    },
    children,
  )

Card.Media = Media
Card.Content = Content

Card.Label = Label

Card.ContentHeader = ContentHeader
Card.Heading = Heading
Card.Text = Text
Card.Metadata = Metadata

Card.Picture = Picture

export default Card
